import React, { useState } from 'react';
import { parseBrazilianNumber } from '../../../utils/formatUtils';
import { FormField, ResultCard } from './shared';

const PointsMilesCalculator = ({ onResultChange }: { onResultChange: (data: { label: string, value: string }[]) => void }) => {
  const [points, setPoints] = useState('10.000');
  const [cost, setCost] = useState('700');
  const [result, setResult] = useState<any>(null);

  const calculate = () => {
    const p = parseFloat(parseBrazilianNumber(points)) || 0;
    const c = parseFloat(parseBrazilianNumber(cost)) || 0;
    if (p <= 0) return;

    const cpp = (c / p) * 1000;
    setResult({ cpp });

    onResultChange([
      { label: 'Pontos/Milhas', value: p.toLocaleString() },
      { label: 'Custo Total', value: `R$ ${c.toLocaleString()}` },
      { label: 'CPP (Milheiro)', value: `R$ ${cpp.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}` }
    ]);
  };

  return (
    <div className="space-y-8">
      <div className="bg-theme-result p-6 rounded-2xl border border-theme-border text-center">
        <h2 className="text-xl font-black text-theme-text mb-2 tracking-tight">Cálculo de Milhas (CPP)</h2>
        <p className="text-theme-muted text-sm">Descubra o custo por milheiro (CPP) de suas emissões ou compras.</p>
      </div>
      <div className="bg-theme-result p-8 rounded-3xl border border-theme-border shadow-sm">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <FormField label="Quantidade de Pontos/Milhas" value={points} onChange={setPoints} isNumeric required />
          <FormField label="Custo Total (R$)" value={cost} onChange={setCost} isNumeric required />
        </div>
        <div className="flex justify-center mt-8">
          <button onClick={calculate} className="px-10 py-4 bg-accent-gradient text-white rounded-xl font-bold shadow-accent hover:scale-105 transition-all">Calcular</button>
        </div>
      </div>
      {result && (
        <div className="max-w-md mx-auto">
          <ResultCard title="CPP (Custo por Milheiro)" value={`R$ ${result.cpp.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}`} color="purple" />
          <div className="mt-4 p-4 bg-theme-input rounded-xl border border-theme-border text-center text-xs text-theme-muted font-medium">
            {result.cpp < 15 ? '✅ EXCELENTE custo-benefício!' : result.cpp < 25 ? '⚠️ Custo razoável.' : '❌ Custo elevado.'}
          </div>
        </div>
      )}
    </div>
  );
};

export default PointsMilesCalculator;
